import React, { useState } from 'react'

import {Box} from '@mui/material'

import useStyles from '../../../styles/global-mui.js';
import LivePopupCreator from './popup/LivePopupCreatorMatch.js';
import { useDispatch, useSelector } from 'react-redux';
import { createLive } from '../../../actions/lives.js';
import { ReactComponent as MySvgIcon } from '../../../images/picto/standard/creer_un_direct_match.svg';
import { ReactComponent as MySvgIconHover } from '../../../images/picto/blue/creer_un_direct_match_bleu.svg';
import DsasButton from '../../../v1/components/DsasButton/DsasButton.js';


const CreateMatchLiveCustom = ({}) => {
    const classes = useStyles();

    const dispatch = useDispatch()

    const [open, setOpen] = useState(false);

     const currentUser = useSelector(state => state.authentication.currentUser);
        const provider = currentUser?.groups; // ou currentUser?.groups si c’est ça le "provider"
        
          const buildInitialLiveData = () => ({
             name : '',
              matchs : [],
              dateTime : new Date(),
              discipline : '',
              userNames : [],
            provider: provider ?? null, // fallback explicite si jamais le user n'est pas encore prêt
            
          });
        
          const [state, setState] = useState(buildInitialLiveData);

      const handleClickOpen = () => {
        if (!provider) {
            console.warn('Provider non défini, popup non ouvert.');
            return;
          }
          setState(buildInitialLiveData());
          setOpen(true);
        };
        
    
    const handleClose = () => {
      setOpen(false);
    };

    const handleConfirm = () => {
      // On veut sauvegarder le match dans son état
      dispatch(createLive(state))
      handleClose()

      setState(buildInitialLiveData())
    }

    const handleCancel = () => {
      setOpen(false);
    }

    // const handleClear = () => {
    //   console.log('handleClear called')
    //   setState(initialLiveData)
    // }

    const RenderIcon = (props) => <MySvgIcon key={props.key} />;
    const RenderIconHover = (props) => <MySvgIconHover key={props.key} />;

    return (
          <Box className='centered-wrapper'>

            <DsasButton 
              label='Créer un direct de matchs' 
              variant='secondary' 
              customIcon={RenderIcon}
              customIconHover={RenderIconHover}
              customCss={{
                display: 'flex',
                alignItems: 'center'}}
              onClick={handleClickOpen} >
            </DsasButton> 

            {/* Rendu hors du Box cliquable */}
            <LivePopupCreator
              open={open}
              setOpen={setOpen}
              handleConfirm={handleConfirm}
              handleCancel={handleCancel}
              state={state}
              setState={setState}
              initialState={buildInitialLiveData()}
            />
         </Box>
        );
}

export default CreateMatchLiveCustom